export const STARTER_TEMPLATES = [
  {
    id: "blank",
    name: "Blank Canvas",
    thumbnail: "blank",
    front: { background: { type: "solid", color: "#ffffff" }, elements: [] },
    back: { background: { type: "solid", color: "#ffffff" }, elements: [] }
  },
  {
    id: "classic",
    name: "Classic Elegant",
    thumbnail: "classic",
    front: {
      background: { type: "gradient", color1: "#f5f5f4", color2: "#e7e5e4", angle: 180 },
      elements: [
        { id: "t1", type: "text", content: "You're Invited", x: 116, y: 60, width: 200, font: "Georgia", fontSize: 28, fontWeight: "bold", color: "#44403c", align: "center" },
        { id: "t2", type: "event_details", x: 116, y: 140, width: 200, showTitle: true, showDate: false, showTime: false, showLocation: false, color: "#57534e" }
      ]
    },
    back: {
      background: { type: "solid", color: "#ffffff" },
      elements: [
        { id: "t3", type: "event_details", x: 20, y: 20, width: 200, showTitle: false, showDate: true, showLocation: true, showHost: true, color: "#44403c" }
      ]
    }
  },
  {
    id: "modern",
    name: "Modern Bold",
    thumbnail: "modern",
    front: {
      background: { type: "gradient", color1: "#1e293b", color2: "#334155", angle: 135 },
      elements: [
        { id: "t1", type: "text", content: "JOIN US", x: 116, y: 50, width: 200, font: "Impact", fontSize: 36, color: "#ffffff", align: "center" },
        { id: "t2", type: "event_details", x: 116, y: 130, width: 200, showTitle: true, showDate: false, color: "#e2e8f0" }
      ]
    },
    back: {
      background: { type: "solid", color: "#f8fafc" },
      elements: [
        { id: "t3", type: "event_details", x: 20, y: 20, width: 200, showTitle: false, showDate: true, showLocation: true, showHost: true, color: "#1e293b" }
      ]
    }
  },
  {
    id: "festive",
    name: "Festive Fun",
    thumbnail: "festive",
    front: {
      background: { type: "gradient", color1: "#fde047", color2: "#facc15", angle: 135 },
      elements: [
        { id: "t1", type: "text", content: "Let's Celebrate!", x: 66, y: 50, width: 300, font: "Comic Sans MS", fontSize: 26, fontWeight: "bold", color: "#713f12", align: "center" },
        { id: "t2", type: "event_details", x: 116, y: 130, width: 200, showTitle: true, showDate: false, color: "#854d0e" }
      ]
    },
    back: {
      background: { type: "solid", color: "#fefce8" },
      elements: [
        { id: "t3", type: "event_details", x: 20, y: 20, width: 200, showTitle: false, showDate: true, showLocation: true, showHost: true, color: "#713f12" }
      ]
    }
  },
  {
    id: "minimal",
    name: "Minimal Clean",
    thumbnail: "minimal",
    front: {
      background: { type: "solid", color: "#ffffff" },
      elements: [
        { id: "t1", type: "event_details", x: 116, y: 100, width: 200, showTitle: true, showDate: true, showLocation: false, color: "#171717" }
      ]
    },
    back: {
      background: { type: "solid", color: "#fafafa" },
      elements: [
        { id: "t3", type: "event_details", x: 20, y: 20, width: 200, showTitle: false, showDate: false, showLocation: true, showHost: true, color: "#404040" }
      ]
    }
  }
]

export function getTemplate(templateId) {
  return STARTER_TEMPLATES.find(t => t.id === templateId)
}
